export default __webpack_public_path__ + "static/media/WellBeingProject.32ad64cd.png";